import { useState, useEffect } from "react";
import { AuthContainer } from "./style";
import { Alert, Spinner } from "reactstrap";

function OtpVerification({
  mobileNumber,
  setShowOtpVerification,
  onSuccess,
  error,
  setError,
  isLoading,
  triggerGetOtp,
}) {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [timer, setTimer] = useState(60);
  const [otpExpired, setOtpExpired] = useState(false);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    } else {
      setOtpExpired(true);
    }
  }, [timer]);

  useEffect(() => {
    if (otp.every((d) => d !== "") && !otpExpired) {
      setError(null);
      onSuccess(otp.join(""));
    } else if (otp.every((d) => d !== "") && otpExpired) {
      setError("OTP has expired. Please resend and try again.");
      setOtp(new Array(6).fill(""));
      const firstInput = document.getElementById(`otp-0`);
      if (firstInput) firstInput.focus();
    }
  }, [otp.join("")]);

  const handleChange = (value, index) => {
    const newOtp = [...otp];

    if (value.length > 1) {
      const pastedOtp = value.replace(/\D/g, "").slice(0, 6);
      const updatedOtp = newOtp.map((_, i) => pastedOtp[i] || "");
      setOtp(updatedOtp);

      const lastFilledIndex = Math.min(pastedOtp.length - 1, 5);
      const lastInput = document.getElementById(`otp-${lastFilledIndex}`);
      if (lastInput) lastInput.focus();

      return;
    }

    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain");
    if (pastedData) {
      handleChange(pastedData, 0);
    }
  };

  const maskMobile = (num) =>
    num ? num.replace(/^(\d{2})\d{6}(\d{2})$/, "$1******$2") : "*******";

  const resendOtp = () => {
    setTimer(60);
    setOtpExpired(false);
    setError(null);
    setOtp(new Array(6).fill(""));
    triggerGetOtp();

    const firstInput = document.getElementById(`otp-0`);
    if (firstInput) firstInput.focus();
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-dark bg-opacity-75 position-relative">
      <AuthContainer className="text-center p-4 rounded-3 bg-white position-relative">
        <div className="d-flex justify-content-end">
          <i
            className="fa-solid fa-xmark fs-4"
            style={{ cursor: "pointer", color: "black", zIndex: 10 }}
            onClick={() => setShowOtpVerification(false)}
          />
        </div>
        <h4>OTP Verification</h4>
        <p>
          A verification code has been sent to your mobile number via WhatsApp,{" "}
          <br />
          <strong>{maskMobile(mobileNumber)}</strong>. Please enter it to
          complete the process.
        </p>

        <div className="d-flex justify-content-center gap-2 my-3">
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-${index}`}
              className="text-center form-control"
              style={{ width: "3rem", fontSize: "1.5rem" }}
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e.target.value, index)}
              onPaste={handlePaste}
              disabled={otpExpired || isLoading}
            />
          ))}
        </div>

        {isLoading && (
          <div className="my-2">
            <Spinner size="sm" /> <span>Verifying...</span>
          </div>
        )}
        {error && (
          <Alert color="danger" className="mt-2 py-1">
            {error}
          </Alert>
        )}

        <h5 className="my-2">
          {String(Math.floor(timer / 60)).padStart(2, "0")}:
          {String(timer % 60).padStart(2, "0")}
        </h5>

        {otpExpired && (
          <Alert color="warning" className="mt-2 py-1">
            OTP has expired. Please resend and try again.
          </Alert>
        )}

        <p>
          Not received OTP?{" "}
          <span
            style={{
              color: timer === 0 ? "#007bff" : "gray",
              cursor: timer === 0 ? "pointer" : "not-allowed",
            }}
            onClick={timer === 0 ? resendOtp : null}
          >
            Resend Now
          </span>
        </p>
      </AuthContainer>
    </div>
  );
}

export default OtpVerification;
